module.exports = __webpack_public_path__ + "img/相似度绑定一键导入.4474474b.svg";